var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32.36 32.36",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{isolation:isolate;}.cls-2{fill:#bc262f;}.cls-3{fill:#0492cd;}.cls-4{fill:#334a87;}.cls-5{mix-blend-mode:multiply;}.cls-6{fill:#5a595c;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Asset 3") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "cls-1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Nav"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M22.83,7.42H20.38L21.61,10,28.3,23.87a14.55,14.55,0,0,0,1.1-2.11l.16-.37Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M19.16,10,17.93,7.42H15.48L16.71,10l1.22,2.55,1.23,2.55L25.1,27.42a14.09,14.09,0,0,0,1.23-1.09c.16-.16.31-.33.46-.49L20.38,12.51Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M16.71,15.06l-1.23-2.55L14.25,10,13,7.42H10.58L11.8,10,13,12.51l1.22,2.55,1.23,2.55,1.23,2.54,4.54,9.46.51-.21a12.85,12.85,0,0,0,1.49-.73L17.93,17.61Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M10.58,7.42h0L3.31,22.53l-1,2A17.4,17.4,0,0,0,3.8,26.6l.88-1.83L11.8,10Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M13,12.51,6.27,26.56l-.83,1.72a17,17,0,0,0,1.79,1.38L8,28l6.22-12.94Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M15.48,17.61,9.94,29.11l-.79,1.65.73.32c.44.19.88.35,1.33.5l.8-1.66,4.7-9.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M31.08,9.88a16,16,0,0,0-3.46-5.14A16.2,16.2,0,0,0,9.88,1.27,16.21,16.21,0,0,0,1.27,22.48a16.8,16.8,0,0,0,1.06,2.07l1-2c-.13-.25-.25-.51-.36-.77a14.35,14.35,0,1,1,26.61-.37l-.16.37a14.55,14.55,0,0,1-1.1,2.11,14.93,14.93,0,0,1-1.51,2c-.15.16-.3.33-.46.49a14.09,14.09,0,0,1-1.23,1.09,14.63,14.63,0,0,1-1.85,1.25,12.85,12.85,0,0,1-1.49.73l-.51.21a14.27,14.27,0,0,1-5.07.92A14.56,14.56,0,0,1,12,29.92l-.8,1.66a16.22,16.22,0,0,0,10.84-.32l.43-.18a15.31,15.31,0,0,0,3.43-2,17.11,17.11,0,0,0,1.71-1.48l0,0a16.88,16.88,0,0,0,1.57-1.83,16.53,16.53,0,0,0,1.38-2.23c.18-.35.34-.7.49-1.06a16.14,16.14,0,0,0,0-12.6Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-5"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "11.8 9.96 10.58 7.42 10.58 7.42 9.35 9.96 10.58 12.51 10.58 12.51 11.8 9.96 11.8 9.96"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "13.03 12.51 11.8 15.06 13.03 17.61 14.25 15.06 13.03 12.51"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "15.48 17.61 14.25 20.15 15.48 22.7 16.7 20.15 15.48 17.61"
  })))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.4cc15339a51afa860d071f41a43a5dfb.svg";
export { ForwardRef as ReactComponent };